import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex items-start justify-start",
  for: "privacy"
}
const _hoisted_2 = { class: "checkbox mr-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "checkmark" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-placeholder" }, [
  /*#__PURE__*/_createTextVNode(" Akceptuję regulamin oraz politykę prywatności portalu oraz ich postanowienia. Podane przeze mnie informacje są prawdziwe. Korzystam z usługi we własnym imieniu i z własnej woli. "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
], -1)
const _hoisted_5 = { class: "error-message" }

import { useField } from 'vee-validate';


export default {
  __name: 'AcceptRegistrationTerms',
  setup(__props) {

const { value, errorMessage } = useField('acceptRegistrationTerms');

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_isRef(value) ? (value).value = $event : null)),
          class: "mr-2",
          type: "checkbox",
          name: "privacy",
          id: "privacy"
        }, null, 512), [
          [_vModelCheckbox, _unref(value)]
        ]),
        _hoisted_3
      ]),
      _hoisted_4
    ]),
    _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(errorMessage)), 1)
  ]))
}
}

}